'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { X } from 'lucide-react';

export default function StickyBottomBar() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-foreground text-white border-t border-white/10 shadow-modal">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 h-12 flex items-center justify-between gap-4">
        <p className="text-sm font-600 text-white/90 hidden sm:block">
          <span className="text-primary font-700">ADVERTISE WITH US</span>
          {' '}— Reach 200K+ industry professionals across the U.S. peptide market.
        </p>
        <p className="text-sm font-700 text-primary sm:hidden">ADVERTISE WITH US</p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Link
            href="/advertise-page"
            className="btn-primary py-1.5 px-4 text-sm"
          >
            See Placements
          </Link>
          <button
            onClick={() => setDismissed(true)}
            aria-label="Dismiss advertise bar"
            className="p-1 rounded hover:bg-white/10 transition-colors text-white/60 hover:text-white"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}